import React from "react";
import Contact from "../components/Contacthero"
import WhyChooseUs from "../components/WhyChooseUs";
import CTAPage from "../components/CTAPage";
import ContactUs from "../components/ContactSection";

const HomePage = ({ isDarkMode }) => {
  
  const facts = [
    "Our team has over 20 years of combined experience.",
    "We’ve completed 100+ successful projects across various industries.",
    "We are committed to providing sustainable tech solutions.",
  ];

  return (
    <>
      <Contact isDarkMode={isDarkMode} />
 
      <WhyChooseUs isDarkMode={isDarkMode} facts={facts} />
    
  
      <ContactUs isDarkMode={isDarkMode} />
      <CTAPage isDarkMode={isDarkMode} />
    </>
  );
};

export default HomePage;
